import React, {
  forwardRef,
  useImperativeHandle,
  useState,
  useRef,
  useCallback,
  useEffect,
} from 'react';
import { connect, useDispatch } from 'react-redux';
import qs from 'qs';
import { Modal, Button } from 'antd';
import ConfrimIframeModal from '../iframModal/ConfrimIframeModal';
import {
  _hide_login_modal,
  _show_login_modal,
  _set_uid_token,
  _get_user_info,
  _is_new_process,
} from '../../store/Action';
import Util from '../../script/util';
import HTTP from '../../script/service';
import './SHWBLogin.scss';

/**
 * 四合网吧授权登录
 * */
const SHWBLogin = forwardRef(({ base }, ref) => {
  useImperativeHandle(ref, () => ({
    showModal: (params) => {
      Util.setCookie('dd_shwb_info', JSON.stringify(params));
      openSHLogin();
    },
  }));
  const openSHLogin = () => {
    const { rootConfig } = base;
    Util.setCookie('dfSearch', window.location.search);
    _hide_login_modal();
    const param = {
      appid: 'daidaitest',
      callback: `${window.location.protocol}//${window.location.host}/loginCallback.html?v=${rootConfig.version}&ty=shwb`,
    };
    const url = `http://laobihai.xyz:20002/oauth/login?${qs.stringify(param)}`;
    console.info('shwb login url: ', url);
    // 四合授权页面使用 iframe 授权成功无法跳转回，所以使用 href 的方式
    window.location.href = url;
  };

  return null;
});

export default connect((store) => ({ base: store }), null, null, {
  forwardRef: true,
})(SHWBLogin);

// 四合授权登录 和 已绑定提示弹窗
export const SHWBLoginAuthModal = connect((store) => ({ base: store }))(({
  base,
}) => {
  const dispatch = useDispatch();
  const { rootConfig, shwbLoginAuthInfo } = base;
  const confirmElement = useRef(null);
  const [avatar, setAvatar] = useState(null);
  const [isAgree, setIsAgree] = useState(false);
  const [modalShow, setModalShow] = useState(false);

  useEffect(() => {
    if (shwbLoginAuthInfo?.avatar) {
      const image = new Image();
      image.src = shwbLoginAuthInfo.avatar;
      image.onload = () => {
        setAvatar(shwbLoginAuthInfo.avatar);
      };
      image.onerror = () => {
        setAvatar(null);
      };
    }
  }, [shwbLoginAuthInfo]);

  /* eslint-disable react-hooks/exhaustive-deps */
  const hideModal = useCallback((isOpen = true) => {
    dispatch({
      type: 'set_shwb_login_auth_info',
      data: { shwbLoginAuthInfo: null },
    });
    isOpen && _show_login_modal();
  }, []);

  // 确认授权
  const handleSubmit = async () => {
    const res = await HTTP._bind_user_shwb({
      openId: shwbLoginAuthInfo.openId,
      accessKey: shwbLoginAuthInfo.accessKey,
      token: shwbLoginAuthInfo.shwbUserInfo.accessToken,
      uid: shwbLoginAuthInfo.shwbUserInfo.uid,
      noInToken: false,
      ...shwbLoginAuthInfo.shwbInfo,
    });
    if (res?.code === 200) {
      checkLoginTokenUserInfo(() => {
        if (shwbLoginAuthInfo.shwbUserInfo) {
          _is_new_process(shwbLoginAuthInfo.shwbUserInfo); // 新用户注册流程
        }
        hideModal(false);
      });
    }
    shwbLoginAuthInfo?.callback && shwbLoginAuthInfo.callback();
  };

  const checkLoginTokenUserInfo = useCallback(
    (callback) => {
      _set_uid_token({
        token: shwbLoginAuthInfo.shwbUserInfo.accessToken,
        uid: shwbLoginAuthInfo.shwbUserInfo.uid,
        register: shwbLoginAuthInfo.shwbUserInfo.register,
        qKey: 'newLogin2',
      });
      _get_user_info(
        {
          token: shwbLoginAuthInfo.shwbUserInfo.accessToken,
          uid: shwbLoginAuthInfo.shwbUserInfo.uid,
          qKey: 'check_login_token',
        },
        (data) => {
          callback && callback(data || null);
        }
      );
    },
    [shwbLoginAuthInfo]
  );

  /* eslint-disable react-hooks/exhaustive-deps */
  const isAgreeProtocol = useCallback(() => {
    setIsAgree((bool) => !bool);
  }, [isAgree]);

  const openModel = useCallback(
    (title, url) => {
      const mobilePath = rootConfig?.protocolPath || rootConfig.mobilePath;
      let modalurl = mobilePath + url + '?v=' + rootConfig.version;
      confirmElement.current.showModal({
        url: modalurl,
        title: title,
        scrolling: 'yes',
        width: '1000px',
        height: '600px',
        zIndex: 1010,
      });
    },
    [rootConfig]
  );

  if (!shwbLoginAuthInfo) return null;
  return (
    <>
      <Modal
        open={true}
        title="四合用户授权登录"
        wrapClassName="daidai-modal-style has-top-border shwb-login-info-modal"
        maskClosable={false}
        centered
        width={400}
        footer={null}
        onCancel={() => hideModal(false)}
      >
        <p className="txt-desc">
          {shwbLoginAuthInfo?.isAuth ? (
            '请确认您的基本信息：'
          ) : (
            <>
              该账号已和<span className="phone">{shwbLoginAuthInfo.phone}</span>
              授权绑定
            </>
          )}
        </p>
        <div className="sh-user-info">
          <div className="sh-avatar">
            <img
              src={Util.transImgUrl(avatar)}
              alt={shwbLoginAuthInfo.nickName}
            />
          </div>
          <div className="user-info">
            <p className="sh-name">昵称：{shwbLoginAuthInfo.nickName}</p>
            <p className="sh-id">四合id：{shwbLoginAuthInfo.openId}</p>
          </div>
        </div>
        {shwbLoginAuthInfo?.isAuth && (
          <div className="agreement">
            <span onClick={isAgreeProtocol} className="radio">
              {isAgree && <i />}
            </span>
            <span className="desc">
              我已阅读并同意
              <span
                onClick={() =>
                  openModel('用户协议', '/appagreement/index.html')
                }
              >
                《带带用户服务协议》
              </span>
              <span
                onClick={() => openModel('隐私协议', '/privacy/index.html')}
              >
                《带带隐私协议》
              </span>
            </span>
          </div>
        )}
        <div className="footer-content">
          {shwbLoginAuthInfo?.isAuth ? (
            <>
              <Button className="daidai-btn" onClick={() => hideModal()}>
                取消
              </Button>
              <Button
                className="daidai-btn-primary"
                onClick={handleSubmit}
                disabled={!isAgree}
              >
                确认授权
              </Button>
            </>
          ) : (
            <Button className="daidai-btn-primary" onClick={() => hideModal()}>
              使用 {shwbLoginAuthInfo.phone} 进行登录
            </Button>
          )}
        </div>
      </Modal>
      {/* 通用弹窗 */}
      <ConfrimIframeModal wrappedComponentRef={confirmElement} />
    </>
  );
});
